import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const settings = accountId => ({
  parentNav: 'settings',
  routes: [
    'agent_bots',
    'agent_list',
    'attributes_list',
    'automation_list',
    'auditlogs_list',
    'billing_settings_index',
    'canned_list',
    'knowledge_sources_list', // @knowledge_sources
    'chatgpt_list',
    'general_settings_index',
    'general_settings',
    'labels_list',
    'macros_edit',
    'macros_new',
    'macros_wrapper',
    'settings_applications_integration',
    'settings_applications_webhook',
    'settings_applications',
    'settings_inbox_finish',
    'settings_inbox_list',
    'settings_inbox_new',
    'settings_inbox_show',
    'settings_inboxes_add_agents',
    'settings_inboxes_page_channel',
    'whatsapp_templates_index', // @waba_templates
    'whatsapp_templates_wrapper', // @waba_templates
    'settings_integrations_dashboard_apps',
    'settings_integrations_integration',
    'settings_integrations_slack',
    'settings_integrations_webhook',
    'settings_integrations',
    'settings_teams_add_agents',
    'settings_teams_edit_finish',
    'settings_teams_edit_members',
    'settings_teams_edit',
    'settings_teams_finish',
    'settings_teams_list',
    'settings_teams_new',
    'sla_list',
    'custom_roles_list',
    'website_sketch_list', // ← Website Sketch API MNDN 
    'tracking_templates_list', // proyecto@tracking_templates
  ],
  menuItems: [
    {
      icon: 'briefcase',
      label: 'ACCOUNT_SETTINGS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/general`),
      toStateName: 'general_settings_index',
    },
    {
      icon: 'people',
      label: 'AGENTS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/agents/list`),
      toStateName: 'agent_list',
      featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
    },
    {
      icon: 'people-team',
      label: 'TEAMS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/teams/list`),
      toStateName: 'settings_teams_list',
      featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
    },
    {
      icon: 'mail-inbox-all',
      label: 'INBOXES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/inboxes/list`),
      toStateName: 'settings_inbox_list',
      featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
    },
    { // @waba_templates
      icon: 'chat-multiple',
      label: 'WHATSAPP_TEMPLATES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/whatsapp-templates/list`
      ),
      toStateName: 'whatsapp_templates_index',
      featureFlag: FEATURE_FLAGS.WHATSAPP_TEMPLATES,
    },
    {
      icon: 'tag',
      label: 'LABELS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/labels/list`),
      toStateName: 'labels_list',
      featureFlag: FEATURE_FLAGS.LABELS,
    },
    {
      icon: 'code',
      label: 'CUSTOM_ATTRIBUTES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/custom-attributes/list`
      ),
      toStateName: 'attributes_list',
      featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
    },
    {
      icon: 'automation',
      label: 'AUTOMATION',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/automation/list`),
      toStateName: 'automation_list',
      featureFlag: FEATURE_FLAGS.AUTOMATIONS,
    },
    // {
    //   icon: 'bot',
    //   label: 'AGENT_BOTS',
    //   hasSubMenu: false,
    //   meta: {
    //     permissions: ['administrator'],
    //   },
    //   globalConfigFlag: 'csmlEditorHost',
    //   toState: frontendURL(`accounts/${accountId}/settings/agent-bots`),
    //   toStateName: 'agent_bots',
    //   featureFlag: FEATURE_FLAGS.AGENT_BOTS,
    // },
    {
      icon: 'flash-settings',
      label: 'MACROS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/macros`),
      toStateName: 'macros_wrapper',
      featureFlag: FEATURE_FLAGS.MACROS,
    },
    {
      icon: 'chat-multiple',
      label: 'CANNED_RESPONSES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/canned-response/list`
      ),
      toStateName: 'canned_list',
      featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
    },
    { // @knowledge_sources
      icon: 'library',
      label: 'KNOWLEDGE_SOURCES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/knowledge-sources/list`
      ),
      toStateName: 'knowledge_sources_list',
    },
    {
      icon: 'bot',
      label: 'CHATGPT',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/chatgpt/list`),
      toStateName: 'chatgpt_list',
      featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
    },
    { // proyecto@tracking_templates
      icon: 'document-list-clock',
      label: 'TRACKING_TEMPLATES',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/tracking-templates/list`
      ),
      toStateName: 'tracking_templates_list',
    },
    {
      icon: 'flash-on',
      label: 'INTEGRATIONS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/integrations`),
      toStateName: 'settings_applications',
      featureFlag: FEATURE_FLAGS.INTEGRATIONS,
    },
    // Website Sketch API MNDN -INI
    {
      icon: 'search',
      label: 'SITE_ANALYSIS',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/website-sketch/list`),
      toStateName: 'website_sketch_list',
    },
    // Website Sketch API MNDN -FIN

    // {
    //   icon: 'key',
    //   label: 'AUDIT_LOGS',
    //   hasSubMenu: false,
    //   meta: {
    //     permissions: ['administrator'],
    //   },
    //   toState: frontendURL(`accounts/${accountId}/settings/audit-logs/list`),
    //   toStateName: 'auditlogs_list',
    //   isEnterpriseOnly: true,
    //   featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
    // },
    // {
    //   icon: 'scan-person',
    //   label: 'CUSTOM_ROLES',
    //   hasSubMenu: false,
    //   meta: {
    //     permissions: ['administrator'],
    //   },
    //   toState: frontendURL(`accounts/${accountId}/settings/custom-roles/list`),
    //   toStateName: 'custom_roles_list',
    //   isEnterpriseOnly: true,
    //   beta: true,
    // },
    // {
    //   icon: 'document-list-clock',
    //   label: 'SLA',
    //   hasSubMenu: false,
    //   meta: {
    //     permissions: ['administrator'],
    //   },
    //   toState: frontendURL(`accounts/${accountId}/settings/sla/list`),
    //   toStateName: 'sla_list',
    //   isEnterpriseOnly: true,
    //   featureFlag: FEATURE_FLAGS.SLA,
    //   beta: true,
    // },
    {
      icon: 'credit-card-person',
      label: 'BILLING',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/billing`),
      toStateName: 'billing_settings_index',
      showOnlyOnCloud: true,
    },
  ],
});

export default settings;
